import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NitroCheckbox, NitroSingleSelect } from 'nitro-components';
import { MockRegos, MockProviders } from './mockRows';
import { FuelCardInput } from '../styles';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
`;

const RowCenter = styled(Row)`
  align-items: center;
`;

const Title = styled.p`
  margin: 8px 0;
  flex-shrink: 0;
  width: 25%;
  min-width: 150px;
  max-width: 300px;
  font-family: ${props => props.theme.font.bold};
`;

const Select = styled(NitroSingleSelect)`
  flex-basis: 50%;
  width: auto;
  flex-grow: 1;
  flex-shrink: 1;
  border: ${props => (props.error ? '1px solid red' : '')};
`;

const GrowContainer = styled.div`
  flex-grow: 1;
`;

const ResponsiveInput = styled(FuelCardInput)`
  flex-basis: 50%;
  width: auto;
  flex-grow: 1;
  flex-shrink: 1;
`;

const Separator = styled.div`
  margin: 0 8px;
`;

export const INITIAL_ORDER_FORM = {
  registration: null,
  provider: null,
  recipientName: '',
  address2: '',
  streetNumber: '',
  address: '',
  suburb: '',
  postCode: '',
  state: '',
  country: ''
};

export const FORM_TYPE = {
  businessAddress: 'Business Address',
  driverAddress: 'Driver Address'
};

const COUNTRIES = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' }
];

class OrderFuelCardForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      fields,
      disabled,
      errors,
      onUpdate,
      formType,
      onUpdateFormType
    } = this.props;

    return (
      <div>
        <Row>
          <Title>Rego Number:</Title>
          <Select
            error={errors.registration}
            disabled={disabled}
            mandatory
            options={MockRegos}
            action={e => {
              onUpdate('registration', e.value);
            }}
            value={fields.registration}
            placeholder="Please Select"
          />
        </Row>
        <Row>
          <Title>Select Provider:</Title>
          <Select
            error={errors.provider}
            disabled={disabled}
            mandatory
            options={MockProviders}
            action={e => {
              onUpdate('provider', e.value);
            }}
            value={fields.provider}
            placeholder="Please Select"
          />
        </Row>
        <RowCenter>
          <Title>Send To:</Title>
          {Object.values(FORM_TYPE).map(sendToType => (
            <NitroCheckbox
              disabled={disabled}
              key={sendToType}
              label={sendToType}
              checked={formType === sendToType}
              action={() => onUpdateFormType(sendToType)}
            />
          ))}
        </RowCenter>
        {formType === FORM_TYPE.driverAddress ? (
          <Row>
            <Title>Recipient Name</Title>
            <ResponsiveInput
              error={errors.recipientName}
              underlineShow={false}
              disabled={disabled}
              placeholder="Recipient Name"
              value={fields.recipientName}
              onChange={e => onUpdate('recipientName', e.target.value)}
            />
          </Row>
        ) : null}
        <Row>
          <Title>Address</Title>
          <GrowContainer>
            <Row>
              <ResponsiveInput
                error={errors.address2}
                underlineShow={false}
                disabled={disabled}
                placeholder="Unit / Lot Number"
                value={fields.address2}
                onChange={e => onUpdate('address2', e.target.value)}
              />
              <Separator />
              <ResponsiveInput
                error={errors.streetNumber}
                underlineShow={false}
                disabled={disabled}
                placeholder="Street Number"
                value={fields.streetNumber}
                onChange={e => onUpdate('streetNumber', e.target.value)}
              />
            </Row>
            <Row>
              <ResponsiveInput
                error={errors.address}
                underlineShow={false}
                disabled={disabled}
                placeholder="Address"
                value={fields.address}
                onChange={e => onUpdate('address', e.target.value)}
              />
            </Row>
            <Row>
              <ResponsiveInput
                error={errors.suburb}
                underlineShow={false}
                disabled={disabled}
                placeholder="Suburb"
                value={fields.suburb}
                onChange={e => onUpdate('suburb', e.target.value)}
              />
              <Separator />
              <ResponsiveInput
                error={errors.postCode}
                underlineShow={false}
                disabled={disabled}
                placeholder="Post Code"
                value={fields.postCode}
                onChange={e => onUpdate('postCode', e.target.value)}
              />
            </Row>
            <Row>
              <ResponsiveInput
                error={errors.state}
                underlineShow={false}
                disabled={disabled}
                placeholder="State"
                value={fields.state}
                onChange={e => onUpdate('state', e.target.value)}
              />
              <Separator />
              <Select
                error={errors.country}
                disabled={disabled}
                mandatory
                options={COUNTRIES}
                action={e => onUpdate('country', e.value)}
                value={fields.country}
                placeholder="Country"
              />
            </Row>
          </GrowContainer>
        </Row>
      </div>
    );
  }
}

OrderFuelCardForm.defaultProps = {
  fields: { ...INITIAL_ORDER_FORM },
  disabled: false,
  errors: { ...INITIAL_ORDER_FORM }
};

OrderFuelCardForm.propTypes = {
  /**
   * Fields that will be displayed in this form
   */
  fields: PropTypes.object,

  /**
   * Action invoked when one of the form fields has been updated
   */
  onUpdate: PropTypes.func.isRequired,

  /**
   * True if all fields in the form should be disabled
   */
  disabled: PropTypes.bool,

  /**
   * A map of all form fields marked true if the field has an error
   */
  errors: PropTypes.object,

  /**
   * The type of form to display (businessAddress || driverAddress)
   */
  formType: PropTypes.string.isRequired,

  /**
   * Action invoked when the form type changes
   */
  onUpdateFormType: PropTypes.func.isRequired
};

export default OrderFuelCardForm;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/order-fuel-card/order-fuel-card-form.js